<template>
	<div class="base">
		<section role="region" aria-label="תפריט ראשי" id="headerC" class="header">
		<div id="video-player" >
		<div class="plyr__video-embed" id="player">
    <iframe src="https://www.youtube.com/embed/dE6I_2Ise7k?autoplay=1&iv_load_policy=3&modestbranding=0&playsinline=1showinfo=0&rel=0&enablejsapi=1?&autohide=1&controls=1&mute=1" allowfullscreen allowtransparency allow="autoplay" style="position:absolute;z-index: 8;" id="yuPlayer"></iframe>
</div>
				</div>
			<div  class="header-content">
				<div id="content-wrapper">
				<div role="menu" class="header-menu">
					<div class="menu-wrapper" >
						<div tabindex="0" role="button" class="menuButton"><a v-on:click="scrollToWorking()">איך זה עובד?</a></div>
						<div tabindex="-1" role="none" class="menuButton">|</div>
						<div tabindex="0" role="button" class="menuButton" v-on:click="scrollToGallery()"><a>כך זה נראה</a></div>
						<div tabindex="-1" role="none" class="menuButton">|</div>
						<div tabindex="0" role="button" class="menuButton" v-on:click="scrollToTeam()"><a>צוות החצר</a></div>
						<div tabindex="-1" role="none"  class="menuButton">|</div>
						<div tabindex="0" role="button" class="menuButton" v-on:click="scrollToFaqs()"><a>שאלות נפוצות</a></div>
						<div  tabindex="-1" role="none" class="menuButton">|</div>
						<div tabindex="0" role="button" class="menuButton" v-on:click="toggleTalkToMe()"><a>צור קשר</a></div>
						<div  tabindex="-1" role="none" class="menuButton">|</div>
						<div tabindex="0" role="button" class="menuButton" ><v-link href="/rhythm"><a>רישום לאודישן</a></v-link>
								<transition   name="slide-fade">
<div class="menuAuditionButtons" v-show="auditionButtonOpen">

				<div tabindex="0" class="menuButton">
					<v-link href="/rhythm"><a>אודישן להרכב</a></v-link>
				</div>

				<div tabindex="0" class="menuButton">
					<v-link href="/ensemble"><a>אודישן לאנסמבל הקולי</a></v-link>
				</div>
			</div>
		</transition>
						</div>
					</div>
				</div>
				<div class="header-logo">
					<div class="logo-img" v-bind:style="{height: logoHeaderHeight() + 'px'}">
						<img alt="החצר" id="headerlogo" src="images/logo-and-tagline.png" v-on:click="scrollToHome()"/>
					</div>
				</div>
				
				<div role="heading" aria-level="3" aria-label="subtitle" class="header-title-mobile">
					<div>קהילה מקצועית למוסיקאים חובבים</div>
				</div>
				
				<div class="header-logo-mobile">
					<div class="logo-mobile-img" >
						<img alt="החצר" id="headermobilelogo" src="images/upper-logo---solo.png" v-on:click="scrollToHome()"/>
					</div>
				</div>
				

				<div role="button" aria-label="menu" class="header-mobile-menu" v-on:click="showMenu()">

					<div class="divider"></div></br>
					<div class="divider"></div></br>
					<div class="divider"></div>

				</div>

				<transition name="slide-fade">
				<div class="menu-mobile-wrapper"  v-show="menuVisible">
						<div role="button" class="menuButton"><a v-on:click="scrollToWorking()">איך זה עובד?</a></div>
						<div role="button" class="menuButton" v-on:click="scrollToGallery()"><a>כך זה נראה</a></div>
						<div role="button" class="menuButton" v-on:click="scrollToTeam()"><a>צוות החצר</a></div>
						<div role="button" class="menuButton" v-on:click="scrollToFaqs()"><a>שאלות נפוצות</a></div>
						<div role="button" class="menuButton" v-on:click="toggleTalkToMe()"><a>צור קשר</a></div>
						<div role="button" class="menuButton" ><v-link href="/rhythm"><a>רישום לאודישן</a></v-link>
								<transition   name="slide-fade">
			<div class="menuAuditionButtons" style="padding-top:8px;" v-show="auditionButtonOpen">

				<div role="button" class="menuButton">
					<v-link href="/rhythm">אודישן להרכב</v-link>
				</div>

				<div role="button" class="menuButton" style="margin-bottom:-10px;">
					<v-link href="/ensemble">אודישן לאנסמבל</v-link>
				</div>
			</div>
		</transition>
						</div>
				</div>
				</transition>
				</div>
			</div>


			<!--/div id="player-controls" class="player-controls">
				<img alt="נגן" class='video-pause-control' src="images/pause.png"  v-on:click="PauseOrPlayVideo()"/>
				<img alt="עצור" class="video-volume-control" src="images/sound-off.png"  v-on:click="MuteOrVolumeVideo()" v-if="videoIsMuted" />
				<img alt="השתק" class="video-volume-control" src="images/sound-on.png"  v-on:click="MuteOrVolumeVideo()"  v-else/>
			</div -->
	
		<div class="talkToMeAligner">
				<div class="talkToBackground">
					<div class="talkToMeWrapper">
						<TalkToMeHeader uid="firstTalkToMeHeader"></TalkToMeHeader>
					</div>
				</div>
		</div>
			<TalkToMe auditionType='Rhythm' v-if="showContactDialog" @close="toggleTalkToMe()"></TalkToMe>
		</section>

    <slot></slot>

			<section role="region" aria-label="תחתית הדף" id="footerC" class="footer">
			<div class="back-yards-credit">
				<div class="footer-logo">
					<div class="footer-logo-img">
						<img alt="החצר" class="fillImg" src="images/site-bottom-logo.png"/>
					</div>
					<br>
					<a aria-label="facebook (opens in a new page)" target="_blank" href="https://www.facebook.com/yardbands">
						<div id="social1" class="footer-social">
							<img alt="החצר בפייסבוק" class="fillImg" src="images/social1.png"/>
						</div>
					</a>
					<a aria-label="instagram (opens in a new page)" target="_blank" href="https://www.instagram.com/yardbands">
						<div id="social2" class="footer-social">
							<img alt="החצר באינסטגרם" class="fillImg" src="images/social2.png"/>
						</div>
					</a>
					<a aria-label="youtube channel (opens in a new page)" target="_blank" href="https://www.youtube.com/channel/UCSbxr9Lhw29M_cVdDDsW8EA/playlists">
						<div id="social3" class="footer-social">
							<img alt="החצר ביוטיוב" class="fillImg" src="images/social3.png"/>
						</div>
					</a>
				</div>
				<div class="contacts">
					<p><strong>
					החצר צפון: <a href="tel:0507731726">050-7731726</a>
					 | <a href="mailto:NOFFICE@YARDBANDS.COM">NOFFICE@YARDBANDS.COM</a>
					<br>
					החצר מרכז: <a href="tel:0547737094">054-7737094</a>
					 | <a href="mailto:OFFICE@YARDBANDS.COM">OFFICE@YARDBANDS.COM</a>
					<br>
					כל הזכויות שמורות לחצר
					</strong>
					</br>
					<a aria-label="privacy policy (opens in a new page)" target="_blank" href="http://yard-bands.herokuapp.com/privacyPolicy.pdf"><strong>מדיניות פרטיות</strong></a>|
					<a aria-label="usage conditions (opens in a new page)" target="_blank" href="http://yard-bands.herokuapp.com/privacyPolicy.pdf"><strong>תנאי שימוש</strong></a>
					</p>
				</div>
			</div>
		</section>
			<div role="navigation" aria-label="קרדיט" class="credits">
				<p><strong><a style="color:#FF632B" href="https://www.designninjas.org">DESIGN: DOVEV ALPERSON (DESIGN NINJAS)</a> | CODE BY YUVAL DERI (PARAREACH) | PHOTOGRAPY BY ILAN BURLA</strong></p>
			</div>
  </div>
</template>

<script>
  import VLink from '../components/VLink.vue'
  import page from 'page'
  import VueScrollTo from 'vue-scrollto'
  import TalkToMeHeader from '../components/TalkToMeHeader.vue'
  import TalkToMe from '../components/TalkToMe.vue'
  export default {
    components: {
      VLink,TalkToMeHeader,TalkToMe
    },
	created () {
		window.addEventListener('scroll', this.handleScroll);
		this.videoIsMuted = true;
		this.videoPlaying = true;
		this.menuVisible = false;
		this.showContactDialog = false;
		this.auditionButtonOpen = false;
		this.scrollAnimationProgress = 1.0 - (Math.min(window.scrollY, 500) / 500.0);

	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	},
	data() {
		return {
			videoIsMuted : true,
			videoPlaying : true
		}
	},
	methods: {
		PauseOrPlayVideo() {
			this.videoPlaying = !this.videoPlaying;
			jwplayer("video-player").play(this.videoPlaying);
		},
		MuteOrVolumeVideo() {
			this.videoIsMuted = !this.videoIsMuted;

			jwplayer("video-player").setMute(this.videoIsMuted);

		},
		scrollToFaqs() {
			this.$scrollTo("#FAQS",800, {'offset':-180})
		},
		scrollToGallery() {
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#gallery", 800, {'offset':-200})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#gallery", 800, {'offset':-200})
			}
		},
		scrollToWorking(){
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#working", 800, {'offset':-250})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#working", 800, {'offset':-250})
			}
		},
		scrollToTeam() {
			if (!window.location.href.substring(window.location.origin.length).includes('team')) {
				page.redirect('/team');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#team", 800, {'offset':-250})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#team", 800, {'offset':-250})
			}
		},
		scrollToHome() {
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				this.$scrollTo("body", 0, {'offset':0})
				setTimeout(function(){
					window.pageLoaded();
				}.bind(this),500);

			}
			else {
				this.$scrollTo("body", 0, {'offset':0})
			}
		},
		handleScroll() {
			this.scrollAnimationProgress = 1.0 - (Math.min(window.scrollY, 500) / 500.0);
			this.$forceUpdate();
		},
		logoHeaderWidth : function() {
			return this.scrollAnimationProgress * 100 +120
		},
		logoHeaderHeight : function() {
			 return this.scrollAnimationProgress * 60 + 60
		},
		logoHeaderPadding : function() {
			 return (1-this.scrollAnimationProgress) * 5
		},
		showMenu() {
			this.menuVisible = !this.menuVisible;
			this.$forceUpdate();
		},
		toggleAudition() {
			this.auditionButtonOpen = !this.auditionButtonOpen
			this.$forceUpdate();
		},
		toggleTalkToMe() {
			this.showContactDialog = !this.showContactDialog;
			this.$forceUpdate();
		}
	}
  }
</script>

<style scoped>
  .container {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background: #000000;
  }
</style>



// WEBPACK FOOTER //
// Main.vue?69f356b8